import type { FC } from 'react';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import { Spinner } from '@/components/Loaders/Spinner';
import { useDownloadExport } from '@/services/hooks/exports/useDownload';
import { Link } from '@/components/link';
import { Table as messages } from './dialog/messages';

export interface DownloadExportLinkProps {
  exportId: string;
}

export const DownloadExportLink: FC<DownloadExportLinkProps> = ({ exportId }) => {
  const { mutate: downloadExport, isLoading: isDownloadingExport } = useDownloadExport();

  if (isDownloadingExport) return <Spinner padding={0} size="small" />;

  return (
    // @ts-expect-error Link component expects a `to` prop, but we are using it for an action
    <Link style={{ wordBreak: 'break-all' }} onClick={() => downloadExport({ exportId })}>
      <FormattedMessage {...messages.download} />
    </Link>
  );
};
